import { render, staticRenderFns } from "./ConfirmDownloadModal.vue?vue&type=template&id=ffa33b48&scoped=true&"
import script from "./ConfirmDownloadModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDownloadModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDownloadModal.vue?vue&type=style&index=0&id=ffa33b48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa33b48",
  null
  
)

export default component.exports